enum RouteUrl {
  EntryPoint = '/search',
  MainFlow = '/main-flow',
  Error = '/error',
  Success = '/success',
  Support = '/support',
}

export default RouteUrl;
